module.exports = __webpack_public_path__ + "assets/media/incoming-sms.48c1e4c7.mp3";